import React from 'react';

import Link from '../../shared/components/hyperlink';
import HeroBanner from '../../hero-banner/hero-banner';

const  isNonEmptyString = (str) => typeof str === 'string' && str.trim().length > 0;

export default ({dlpBanner, css, renderCSS, shouldRenderCSS}) => {

    const { bannerImage,
            disableImageBanner,
            bannerText,
            bannerAlt,
            bannerTitle,
            ctaLink,
            ctaText } = dlpBanner || {};

    const shouldRenderBannerImage = (
      !disableImageBanner &&
      bannerImage && isNonEmptyString(bannerImage.url)
    );

    const hasCTA = isNonEmptyString(ctaLink);
    const hasBannerText = isNonEmptyString(bannerText);
    const hasCTAText = isNonEmptyString(ctaText);
    const hasBannerAlt = isNonEmptyString(bannerAlt);
    const hasBannerTitle = isNonEmptyString(bannerTitle);

    const bannerImageElement = (
      <img className="hero-image"
            src={bannerImage.url}
            alt={ hasBannerAlt ? bannerAlt : null }
            title={ hasBannerTitle ? bannerTitle : null } />
    );

    return  shouldRenderBannerImage && (
          <div className="dlp-banner-container">
            { renderCSS(css) }
            <HeroBanner className="featured-product-banner dlp-banner">
                {
                  bannerImage && (
                    hasCTA ? (
                      <Link to={ctaLink}>
                        { bannerImageElement }
                      </Link>
                    ) : (
                      bannerImageElement
                    )
                  )
                }
                <div className="dlp-banner-text-container">
                  { hasBannerText &&  <h2 className="dlp-banner-text">{bannerText}</h2> }
                  { hasCTA && hasCTAText && <Link className="dlp-banner-cta btn" to={ctaLink}>{ctaText}</Link> }
                </div>
            </HeroBanner>
          </div>
    );
}
